module.exports = __webpack_public_path__ + "img/mouse-circle.95f908af.svg";